import Vue from "vue";

Vue.mixin({
    data() {
        return {
            forceUpdateHelper: false
        };
    },
    methods: {
        checkState: function(fieldName) {
            return this.fieldIsDirty(fieldName) ? !this.errors.has(fieldName) : null;
        },
        fieldIsDirty: function(fieldName) {
            return this.vfields[fieldName] && this.vfields[fieldName].dirty;
        },
        forceUpdate() {
            this.forceUpdateHelper = !this.forceUpdateHelper;
        },
        onlyAllowIntegers(event) {
            if (event.charCode === 8 || event.charCode === 0 || event.charCode === 13) return true;
            else if (event.charCode >= 48 && event.charCode <= 57) return true;
            else event.preventDefault();
        }
    }
});

export default {
    calculateMonthDifference(actualDate, itemDate) {
        var months = (actualDate.getFullYear() - itemDate.getFullYear()) * 12;
        months += actualDate.getMonth() - itemDate.getMonth();
        return months;
    }
};
